// import React, { useEffect, useRef, useState } from "react";
// import { jsPDF } from "jspdf";
// import * as XLSX from "xlsx";
// import moment from "moment";
// import { TabulatorFull as Tabulator } from "tabulator-tables";
// import "tabulator-tables/dist/css/tabulator.min.css";
// import "./Demotable.css";
// import Select from "react-select";
// import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../common/Constant";

// window.jspdf = { jsPDF };
// window.XLSX = XLSX;

// const CommonTabular = ({
//   Data,
//   columns,
//   Groupvalue,
//   Reportname,
//   frozenRowvalue,
//   grouppermission = true,
//   layout = "fitColumns",
//   height = "700px",
//   Onrefresh,
//   dataTree = false,
//   dataTreeStartExpanded = "",
//   onRowClick,
// }) => {
//   const tableRef = useRef(null);
//   const tabulatorRef = useRef(null);

//   const [isGroupsExpanded, setIsGroupsExpanded] = useState(true);
//   const [filter, setFilter] = useState(false);
//   const [groupFields, setGroupFields] = useState(false);

//   // New for checkbox dropdown
//   const [showColumnDropdown, setShowColumnDropdown] = useState(false);
//   const [columnState, setColumnState] = useState(columns);

//   useEffect(() => {
//     if (!tableRef.current) return;

//     tabulatorRef.current = new Tabulator(tableRef.current, {
//       data: Data,
//       columns: columnState.filter((col) => col.defaultVisible),
//       layout: layout,
//       movableRows: true,
//       movableColumns: true,
//       groupBy: Groupvalue,
//       height: height,
//       pagination: "local",
//       paginationCounter: "rows",
//       frozenRows: frozenRowvalue,
//       paginationSize: 150,
//       paginationSizeSelector: [300, 500, 750, 1000],
//       dataTree: dataTree,
//       dataTreeChildField: dataTreeStartExpanded,

//       rowFormatter: function (row) {
//         const data = row.getData();
//         const el = row.getElement();

//         if (data.isChildHeader) {
//           el.style.fontWeight = "bold";
//           el.style.background = "#e0e0e0";
//           el.style.color = "#333";
//         } else if (data.isChild) {
//           el.style.backgroundColor = "#f9f9f9";
//         }
//       },
//     });

//     tabulatorRef.current.on("rowClick", function (e, row) {
//       if (onRowClick) {
//         onRowClick(row.getData(), e);
//       }
//     });

//     return () => {
//       tabulatorRef.current?.destroy();
//     };
//   }, [Data, columnState, Groupvalue, frozenRowvalue, filter]);

//   const handleDownload = (type) => {
//     if (!tabulatorRef.current) return;

//     const date = moment().format("YYYY-MM-DD");
//     const options =
//       type === "pdf" ? { orientation: "portrait" } : { sheetName: Reportname };

//     tabulatorRef.current.download(
//       type,
//       `${Reportname}-${date}.${type}`,
//       options
//     );
//   };

//   const handleToggleGroups = () => {
//     if (!tabulatorRef.current) return;

//     try {
//       tabulatorRef.current.blockRedraw();
//       const groups = tabulatorRef.current.getGroups();
//       groups?.forEach((group) =>
//         isGroupsExpanded ? group.hide() : group.show()
//       );
//     } finally {
//       tabulatorRef.current.restoreRedraw();
//       setIsGroupsExpanded(!isGroupsExpanded);
//     }
//   };

//   const HandleGroupValue = (groupFields) => {
//     if (tabulatorRef.current) {
//       tabulatorRef.current.setGroupBy(groupFields);
//       tabulatorRef.current.redraw();
//     }
//   };

//   const HandleFilter = () => {
//     setFilter(!filter);
//   };

//   const HandleGroup = () => {
//     setGroupFields(!groupFields);
//   };

//   const updateFilter = (Type) => {
//     const fieldEl = document.getElementById("filter-field");
//     const typeEl = document.getElementById("filter-type");
//     const valueEl = document.getElementById("filter-value");
//     const filterVal = fieldEl?.value;
//     const typeVal = typeEl?.value;

//     if (Type === "apply") {
//       if (filterVal) {
//         tabulatorRef.current.setFilter(filterVal, typeVal, valueEl.value);
//       }
//     } else {
//       tabulatorRef.current.clearFilter();
//       fieldEl.value = "";
//       typeEl.value = "";
//       valueEl.value = "";
//     }
//   };

//   const toggleColumnVisibility = (field) => {
//     const updated = columnState.map((col) =>
//       col.field === field
//         ? { ...col, defaultVisible: !col.defaultVisible }
//         : col
//     );
//     setColumnState(updated);

//     // Dynamically update Tabulator's visible columns
//     if (tabulatorRef.current) {
//       tabulatorRef.current.setColumns(updated.filter((c) => c.defaultVisible));
//     }
//   };

//   return (
//     <div className="table-responsive">
//       <div className="table mt-3">
//         <div>
//           <div className="d-flex justify-content-between row">
//             <div className="d-flex w-auto">
//               <div className="col-auto ml-2">
//                 <button
//                   onClick={handleToggleGroups}
//                   className="btn btn-secondary mb-3 "
//                 >
//                   {isGroupsExpanded ? "Collapse All" : "Expand All"}
//                 </button>
//               </div>
//               <div className="col-auto ml-2">
//                 <button
//                   onClick={HandleFilter}
//                   className="btn btn-secondary mb-3 "
//                 >
//                   <i
//                     className={
//                       filter ? "fa fa-arrow-up me-1" : "fa fa-arrow-down me-1"
//                     }
//                   ></i>{" "}
//                   Filter
//                 </button>
//               </div>
//               {grouppermission && (
//                 <div className="col-auto ml-2">
//                   <button
//                     onClick={HandleGroup}
//                     className="btn btn-secondary mb-3 "
//                   >
//                     <i
//                       className={
//                         groupFields
//                           ? "fa fa-arrow-up me-1"
//                           : "fa fa-arrow-down me-1"
//                       }
//                     ></i>{" "}
//                     Group By
//                   </button>
//                 </div>
//               )}
//             </div>
//             <div className="d-flex w-auto ms-auto gap-3">
//               <div className="col-auto ml-2">
//                 <button
//                   className="btn btn-secondary mb-3 w-100"
//                   onClick={() => Onrefresh()}
//                 >
//                   {" "}
//                   Refresh{" "}
//                 </button>
//               </div>
//               <div className="col-auto ml-2">
//                 <button
//                   onClick={() => handleDownload("pdf")}
//                   className="btn btn-secondary mb-3 w-100"
//                 >
//                   Pdf
//                 </button>
//               </div>
//               <div className="col-auto mr-2">
//                 <button
//                   onClick={() => handleDownload("xlsx")}
//                   className="btn btn-secondary mb-3 w-100"
//                 >
//                   Excel
//                 </button>
//               </div>
//             </div>
//           </div>

//           {/* Filter Section */}
//           {filter && (
//             <div className="row g-2 align-items-end mb-4">
//               <div className="col-md-2">
//                 <label htmlFor="filter-field" className="form-label">
//                   Field
//                 </label>
//                 <select
//                   id="filter-field"
//                   className="tabulator-custom-height form-select"
//                 >
//                   {columnState?.map((col, index) => (
//                     <option key={index} value={col.field}>
//                       {col.title}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               <div className="col-md-1">
//                 <label htmlFor="filter-type" className="form-label">
//                   Comparison
//                 </label>
//                 <select
//                   id="filter-type"
//                   className="tabulator-custom-height form-select"
//                 >
//                   <option value="=">=</option>
//                   <option value="<">&lt;</option>
//                   <option value="<=">&lt;=</option>
//                   <option value=">">&gt;</option>
//                   <option value=">=">&gt;=</option>
//                   <option value="!=">!=</option>
//                   <option value="like">like</option>
//                 </select>
//               </div>

//               <div className="col-md-3">
//                 <label htmlFor="filter-value" className="form-label">
//                   Value
//                 </label>
//                 <input
//                   id="filter-value"
//                   type="text"
//                   className="tabulator-custom-height form-control"
//                   placeholder="Value to filter"
//                 />
//               </div>

//               <div className="col-md-auto">
//                 <button
//                   className="btn btn-secondary mb-0 w-100"
//                   onClick={() => updateFilter("apply")}
//                 >
//                   Apply Filter
//                 </button>
//               </div>

//               <div className="col-md-auto">
//                 <button
//                   id="filter-clear"
//                   className="btn btn-secondary mb-0 w-100"
//                   onClick={() => updateFilter("clear")}
//                 >
//                   Clear Filter
//                 </button>
//               </div>
//             </div>
//           )}

//           {/* Group By Section */}
//           {groupFields && (
//             <div className="row g-2 align-items-end mb-4">
//               <div className="col-4">
//                 <Select
//                   options={columnState.map((col) => ({
//                     label: col.title,
//                     value: col.field,
//                   }))}
//                   placeholder="Select Group By"
//                   isMulti={true}
//                   styles={CUSTOM_SELECT_DROPDOWN_STYLE}
//                   onChange={(selectedOptions) => {
//                     const groupFields = selectedOptions?.map(
//                       (opt) => opt.value
//                     );
//                     HandleGroupValue(
//                       groupFields.length > 0 ? groupFields : false
//                     );
//                   }}
//                   className="reports-filter-custom-width custom-select-search"
//                 />
//               </div>
//               <div className="col-3 ml-2">
//                 <button
//                   className="btn btn-secondary mb-0 "
//                   onClick={() => tabulatorRef.current.setGroupBy(false)}
//                 >
//                   Clear Grouping
//                 </button>
//               </div>
//             </div>
//           )}

//           {/* Visible Columns Checkbox Dropdown */}
//           <div className="row g-2 align-items-end mb-4">
//             <div className="col-md-3">
//               <label className="form-label">Visible Columns</label>
//               <div className="dropdown">
//                 <button
//                   className="form-select"
//                   type="button"
//                   onClick={() => setShowColumnDropdown((prev) => !prev)}
//                 >
//                   Select Columns
//                 </button>
//                 {showColumnDropdown && (
//                   <div
//                     className="dropdown-menu show p-2"
//                     style={{
//                       maxHeight: "200px",
//                       overflowY: "auto",
//                       width: "100%",
//                     }}
//                   >
//                     {columnState.map((col, index) => (
//                       <div key={index} className="form-check">
//                         <input
//                           className="form-check-input"
//                           type="checkbox"
//                           id={`col-check-${index}`}
//                           checked={col.defaultVisible}
//                           onChange={() => toggleColumnVisibility(col.field)}
//                         />
//                         <label
//                           className="form-check-label"
//                           htmlFor={`col-check-${index}`}
//                         >
//                           {col.title}
//                         </label>
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>

//           {/* Tabulator Table */}
//           <div ref={tableRef} id="example-table-theme" />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CommonTabular;

import React, { useEffect, useRef, useState } from "react";
import { jsPDF } from "jspdf";
import * as XLSX from "xlsx";
import moment from "moment";
import { TabulatorFull as Tabulator } from "tabulator-tables";
import "tabulator-tables/dist/css/tabulator.min.css";
import "./Demotable.css";
import Select from "react-select";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../common/Constant";

window.jspdf = { jsPDF };
window.XLSX = XLSX;

const CommonTabular = ({
  Data,
  columns,
  Groupvalue,
  Reportname,
  frozenRowvalue,
  grouppermission = true,
  layout = "fitColumns",
  height = "700px",
  Onrefresh,
  dataTree = false,
  dataTreeStartExpanded = "",
  onRowClick,
  handleShowItemsData, // async API function
  isSubTable = false, // <-- NEW PROP
}) => {
  const tableRef = useRef(null);
  const tabulatorRef = useRef(null);

  const [isGroupsExpanded, setIsGroupsExpanded] = useState(true);
  const [filter, setFilter] = useState(false);
  const [groupFields, setGroupFields] = useState(false);
  const [showColumnDropdown, setShowColumnDropdown] = useState(false);
  const [columnState, setColumnState] = useState(columns);

  useEffect(() => {
    if (!tableRef.current) return;

    // If isSubTable = true, add arrow column
    const modifiedColumns = isSubTable
      ? [
          {
            formatter: () => "&#x25BC;", // ▼ arrow
            width: 40,
            hozAlign: "center",
            resizable: false,
            headerSort: false,
            cellClick: async function (e, cell) {
              const row = cell.getRow();

              // Collapse if already expanded
              if (row.getElement().classList.contains("expanded")) {
                row.getElement().classList.remove("expanded");
                const detail = row.getElement().querySelector(".detail-panel");
                if (detail) detail.remove();
                return;
              }

              // Close other expanded rows
              cell
                .getTable()
                .getRows()
                .forEach((r) => {
                  r.getElement().classList.remove("expanded");
                  const d = r.getElement().querySelector(".detail-panel");
                  if (d) d.remove();
                });

              // Expand current row
              row.getElement().classList.add("expanded");
              const holderEl = document.createElement("div");
              holderEl.className = "detail-panel";
              holderEl.style.padding = "10px";
              holderEl.style.background = "#fafafa";
              holderEl.style.width = "100%";
              holderEl.style.boxSizing = "border-box";
              row.getElement().appendChild(holderEl);

              const rowData = row.getData();

              try {
                let detailData = await handleShowItemsData(
                  rowData.SaleID,
                  rowData.EmployeeID
                );

                if (!Array.isArray(detailData)) {
                  detailData = detailData ? [detailData] : [];
                }

                if (detailData.length === 0) {
                  holderEl.innerHTML =
                    "<div style='color:red'>No details available</div>";
                  return;
                }

                const detailColumns = Object.keys(detailData[0]).map((key) => ({
                  title: key,
                  field: key,
                }));

                new Tabulator(holderEl, {
                  data: detailData,
                  layout: "fitColumns",
                  columns: detailColumns,
                });
              } catch (err) {
                console.error("Error loading detail data:", err);
                holderEl.innerHTML =
                  "<div style='color:red'>Failed to load details</div>";
              }
            },
          },
          ...columnState.filter((col) => col.defaultVisible),
        ]
      : [...columnState.filter((col) => col.defaultVisible)]; // No arrow column

    tabulatorRef.current = new Tabulator(tableRef.current, {
      data: Data,
      columns: modifiedColumns,
      layout: layout,
      movableRows: true,
      movableColumns: true,
      groupBy: Groupvalue,
      height: height,
      pagination: "local",
      paginationCounter: "rows",
      frozenRows: frozenRowvalue,
      paginationSize: 150,
      paginationSizeSelector: [300, 500, 750, 1000],
      dataTree: dataTree,
      dataTreeChildField: dataTreeStartExpanded,
      rowFormatter: function (row) {
        const data = row.getData();
        const el = row.getElement();
        if (data.isChildHeader) {
          el.style.fontWeight = "bold";
          el.style.background = "#e0e0e0";
          el.style.color = "#333";
        } else if (data.isChild) {
          el.style.backgroundColor = "#f9f9f9";
        }
      },
    });

    tabulatorRef.current.on("rowClick", function (e, row) {
      if (onRowClick) {
        onRowClick(row.getData(), e);
      }
    });

    return () => {
      tabulatorRef.current?.destroy();
    };
  }, [
    Data,
    columnState,
    Groupvalue,
    frozenRowvalue,
    layout,
    height,
    handleShowItemsData,
    isSubTable, // depend on prop change
  ]);

  const handleDownload = (type) => {
    if (!tabulatorRef.current) return;
    const date = moment().format("YYYY-MM-DD");
    const options =
      type === "pdf" ? { orientation: "portrait" } : { sheetName: Reportname };
    tabulatorRef.current.download(
      type,
      `${Reportname}-${date}.${type}`,
      options
    );
  };

  const handleToggleGroups = () => {
    if (!tabulatorRef.current) return;
    try {
      tabulatorRef.current.blockRedraw();
      const groups = tabulatorRef.current.getGroups();
      groups?.forEach((group) =>
        isGroupsExpanded ? group.hide() : group.show()
      );
    } finally {
      tabulatorRef.current.restoreRedraw();
      setIsGroupsExpanded(!isGroupsExpanded);
    }
  };

  const toggleColumnVisibility = (field) => {
    const updated = columnState.map((col) =>
      col.field === field
        ? { ...col, defaultVisible: !col.defaultVisible }
        : col
    );
    setColumnState(updated);
  };

  const updateFilter = (Type) => {
    const fieldEl = document.getElementById("filter-field");
    const typeEl = document.getElementById("filter-type");
    const valueEl = document.getElementById("filter-value");
    if (Type === "apply") {
      if (fieldEl?.value) {
        tabulatorRef.current.setFilter(
          fieldEl.value,
          typeEl.value,
          valueEl.value
        );
      }
    } else {
      tabulatorRef.current.clearFilter();
      fieldEl.value = "";
      typeEl.value = "";
      valueEl.value = "";
    }
  };

  return (
    <div className="table-responsive">
      <div className="table mt-3">
        <div className="d-flex justify-content-between mb-2">
          <div className="d-flex gap-2">
            <button onClick={handleToggleGroups} className="btn btn-secondary">
              {isGroupsExpanded ? "Collapse All" : "Expand All"}
            </button>
            <button
              onClick={() => setFilter(!filter)}
              className="btn btn-secondary"
            >
              Filter
            </button>
            {grouppermission && (
              <button
                onClick={() => setGroupFields(!groupFields)}
                className="btn btn-secondary"
              >
                Group By
              </button>
            )}
            <button
              className="btn btn-secondary"
              onClick={() => Onrefresh && Onrefresh()}
            >
              Refresh
            </button>
          </div>
          <div className="d-flex gap-2">
            <button
              onClick={() => handleDownload("pdf")}
              className="btn btn-secondary"
            >
              PDF
            </button>
            <button
              onClick={() => handleDownload("xlsx")}
              className="btn btn-secondary"
            >
              Excel
            </button>
          </div>
        </div>

        {filter && (
          <div className="row g-2 align-items-end mb-4">
            <div className="col-md-2">
              <select id="filter-field" className="form-select">
                {columnState.map((col, i) => (
                  <option key={i} value={col.field}>
                    {col.title}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-2">
              <select id="filter-type" className="form-select">
                <option value="=">=</option>
                <option value="<">&lt;</option>
                <option value="<=">&lt;=</option>
                <option value=">">&gt;</option>
                <option value=">=">&gt;=</option>
                <option value="!=">!=</option>
                <option value="like">like</option>
              </select>
            </div>
            <div className="col-md-3">
              <input
                id="filter-value"
                type="text"
                className="form-control"
                placeholder="Value"
              />
            </div>
            <div className="col-md-auto">
              <button
                className="btn btn-secondary"
                onClick={() => updateFilter("apply")}
              >
                Apply
              </button>
            </div>
            <div className="col-md-auto">
              <button
                className="btn btn-secondary"
                onClick={() => updateFilter("clear")}
              >
                Clear
              </button>
            </div>
          </div>
        )}

        {groupFields && (
          <div className="row g-2 align-items-end mb-4">
            <div className="col-4">
              <Select
                options={columnState.map((col) => ({
                  label: col.title,
                  value: col.field,
                }))}
                placeholder="Select Group By"
                isMulti
                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                onChange={(selected) => {
                  const groups = selected?.map((s) => s.value);
                  tabulatorRef.current.setGroupBy(
                    groups.length > 0 ? groups : false
                  );
                }}
              />
            </div>
            <div className="col-3">
              <button
                className="btn btn-secondary"
                onClick={() => tabulatorRef.current.setGroupBy(false)}
              >
                Clear Grouping
              </button>
            </div>
          </div>
        )}

        <div className="row g-2 align-items-end mb-4">
          <div className="col-md-3">
            <label className="form-label mb-0 pb-0">Visible Columns</label>
            <div className="dropdown">
              <button
                className="form-select"
                type="button"
                onClick={() => setShowColumnDropdown((prev) => !prev)}
              >
                Select Columns
              </button>
              {showColumnDropdown && (
                <div
                  className="dropdown-menu show p-2"
                  style={{
                    maxHeight: "200px",
                    overflowY: "auto",
                    width: "100%",
                  }}
                >
                  {columnState.map((col, index) => (
                    <div key={index} className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`col-check-${index}`}
                        checked={col.defaultVisible}
                        onChange={() => toggleColumnVisibility(col.field)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`col-check-${index}`}
                      >
                        {col.title}
                      </label>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        <div ref={tableRef} id="example-table-theme" />
      </div>
    </div>
  );
};

export default CommonTabular;
